import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isFeatureEnabled } from '../shared/utils/feature-flags';

/**
 * Route gate for an environment feature flag (FEATURE_FLAGS). Pair it with
 * the sidenav item's `featureFlag` so a hidden link is never a reachable URL.
 * Flag off → redirect home, the same landing aiModuleGuard uses.
 */
export function featureFlagGuard(flagName: string): CanActivateFn {
  return () =>
    isFeatureEnabled(flagName) ? true : inject(Router).createUrlTree(['/home']);
}
